import { ReactElement } from 'react'

import styles from './accordeon-course-wrapper.module.scss'

interface IAccordeonCardioData {
  title: string
  data: {
    title: string
    key: string
    text: ReactElement
  }[]
}

const CardioProgram = {
  title: 'Программа курса',
  data: [
    {
      title: 'Модуль 1. Первичная и вторичная профилактика сердечно-сосудистых заболеваний',
      key: 'module-1',
      text: (
        <ul className={styles.list}>
          <li>Оценка сердечно-сосудистого риска</li>
          <li>Не медикаментозная профилактика</li>
          <li>Медикаментозная терапия</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 2. Ишемическая болезнь сердца',
      key: 'module-2',
      text: (
        <ul className={styles.list}>
          <li>Диагностика ИБС</li>
          <li>Медикаментозная терапия</li>
          <li>Хирургическое лечение</li>
          <li>Необструктивная ишемическая болезнь сердца</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 3. Хроническая сердечная недостаточность ',
      key: 'module-3',
      text: (
        <ul className={styles.list}>
          <li>Сердечная недостаточность: алгоритм диагностики и лечения</li>
          <li>Клиника Сердечной Недостаточности от «приказов» к «практике»</li>
          <li>Редкие причины СН </li>
          <li>Острая декомпенсация СН</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 4. Нарушения ритма сердца',
      key: 'module-4',
      text: (
        <ul className={styles.list}>
          <li>Фибрилляция предсердий</li>
          <li>Тахикардия с широкими комплексами </li>
          <li>Аритмогенные синокопальные состояния </li>
          <li>ЭКГ</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 5. Клапанные пороки. Итоговая аттестация',
      key: 'module-5',
      text: (
        <ul className={styles.list}>
          <li>Патологии митрального клапана </li>
          <li>Патологии аортального клапана </li>
          <li>Гипертрофическая кардомиопатия </li>
        </ul>
      ),
    },
  ],
}
const NeuroProgram = {
  title: 'Программа курса',
  data: [
    {
      title: 'Модуль 1. Семиотика когнитивных нарушений. Методы обследования пациентов',
      key: 'module-1',
      text: (
        <ul className={styles.list}>
          <li>
            Морфофункциональные основы когнитивных функций. Классификация когнитивных расстройств.
          </li>
          <li>Лабораторное и инструментальное обследование пациентов с когнитивными нарушениями</li>
          <li>Нейропсихологическое тестирование</li>
          <li>Алгоритм диагностического поиска</li>
          <li>
            Классификация недементных когнитивных расстройств, распространённость и профилактика
          </li>
          <li>Болезнь Альцгеймера</li>
          <li>Сосудистые и смешанные когнитивные расстройства</li>
          <li>Деменция с тельцами Леви и лобно-височная деменция</li>
          <li>Обратимые причины деменций</li>
          <li>Делирий</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 2. Лечение когнитивных расстройств',
      key: 'module-2',
      text: (
        <ul className={styles.list}>
          <li>Лечение недементных когнитивных расстройств</li>
          <li>Основные принципы терапии деменции</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 3. Профилактика когнитивных расстройств ',
      key: 'module-3',
      text: (
        <ul className={styles.list}>
          <li>Профилактика когнитивных нарушений у пациентов пожилого и старческого возраста</li>
          <li>
            Формирование программ здорового образа жизни, в том числе программы снижения потребления
            алкоголя и табака, для поддержания и сохранения когнитивной функции
          </li>
        </ul>
      ),
    },
  ],
}
const GeriatricsProgram = {
  title: 'Программа курса',
  data: [
    {
      title: 'Модуль 1. Основы геронтологии и гериатрии. Гериатрическая служба в&nbsp;России',
      key: 'module-1',
      text: (
        <ul className={styles.list}>
          <li>Гериатрическая служба в России</li>
          <li>Система долговременного ухода</li>
          <li>Теории и механизмы старения. Биомаркеры старения</li>
          <li>Демография старения</li>
          <li>Долгожители и сверхдолгожители</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 2. Комплексная гериатрическая оценка (КГО)',
      key: 'module-2',
      text: (
        <ul className={styles.list}>
          <li>КГО: домены, принципы проведения</li>
          <li>Оценка физического и функционального статуса</li>
          <li>Оценка когнитивного статуса. Нейрокогнитивное тестирование</li>
          <li>Полипрагмазия, методы оценки и коррекции</li>
          <li>
            Особенности фармакотерапии в пожилом возрасте. Депрескрайбинг лекарственных препаратов.{' '}
          </li>
        </ul>
      ),
    },
    {
      title: 'Модуль 3. Ведущие гериатрические синдромы',
      key: 'module-3',
      text: (
        <ul className={styles.list}>
          <li>Старческая астения</li>
          <li>Саркопения</li>
          <li>Падения и переломы</li>
          <li>Нарушения походки и равновесия</li>
          <li>Хронический болевой синдром</li>
          <li>Ортостатическая гипотония</li>
          <li>Дисфагия</li>
          <li>Мальнутриция</li>
          <li>Водно-электролитные нарушения</li>
          <li>Недержание мочи</li>
          <li>Депрессия</li>
          <li>Гериатрический делирий</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 4. Возраст-ассоциированные заболевания и тактика их ведения',
      key: 'module-4',
      text: (
        <ul className={styles.list}>
          <li>Старения сердечно-сосудистой системы</li>
          <li>Артериальная гипертония: особенности ведения пожилых пациентов.</li>
          <li>ХСН: тактика ведения</li>
          <li>
            Фибрилляция предсердий. Профилактика кардиоэмболического инсульта. Антикоагулянтная
            терапия
          </li>
          <li>Остеопороз. Профилактика остеопоротических переломов</li>
          <li>Дефицит и недостаточность витамина Д. Значение для лиц пожилого возраста</li>
          <li>Сахарный диабет у лиц пожилого и старческого возраста</li>
          <li>Заболевания щитовидной железы в пожилом возрасте</li>
          <li>Остеоартрит</li>
          <li>Гериатрическая кисть</li>
          <li>Ревматологические заболевания в пожилом возрасте</li>
          <li>Урологические заболевания в пожилом возрасте</li>
          <li>Гинекологические заболевания в пожилом возрасте</li>
          <li>Периоперационное ведение пожилых пациентов</li>
          <li>Недементные когнитивные расстройства</li>
          <li>Деменция. Дифференциальный диагноз</li>
          <li>Болезнь Альцгеймера.</li>
          <li>Болезнь Паркинсона</li>
          <li>Головная боль</li>
          <li>Нарушения сна в пожилом возрасте</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 5. Профилактика в гериатрии',
      key: 'module-5',
      text: (
        <ul className={styles.list}>
          <li>Вакцинация</li>
          <li>Управление старением. Геропротекция</li>
        </ul>
      ),
    },
  ],
}
const OsteporosisProgram = {
  title: 'Программа курса',
  data: [
    {
      title: 'Модуль 1. Остеопороз у пожилых пациентов',
      key: 'module-1',
      text: (
        <ul className={styles.list}>
          <li>Факторы риска остеопороза и переломов костей</li>
          <li>Сенильный остеопороз-гериатрический синдром</li>
          <li>Дефицит витамина D у пожилых лиц</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 2. Методы диагностики остеопороза',
      key: 'module-2',
      text: (
        <ul className={styles.list}>
          <li>Клиническое обследование при подозрении на остеопороз</li>
          <li>Лабораторная диагностика остеопороза</li>
          <li>Инструментальная диагностика остеопороза</li>
          <li>Оценка 10-летнего абсолютного риска переломов (FRAX)</li>
          <li>Дифференциальная диагностика</li>
          <li>Остеосаркопения: патогенез, диагностика</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 3. Терапия остеопороза и клинические рекомендации',
      key: 'module-3',
      text: (
        <ul className={styles.list}>
          <li>Показания для антиостеопоротического лечения</li>
          <li>Лекарственная терапия пациентов с остеопорозом</li>
          <li>Медикаментозное лечение остеопороза после перелома</li>
          <li>Немедикаментозное лечение остеопороза</li>
          <li>Профилактика остеопороза</li>
        </ul>
      ),
    },
  ],
}
const SomnologyProgram = {
  title: 'Программа курса',
  data: [
    {
      title: 'Модуль 1. Базисные знания по сомнологии',
      key: 'module-1',
      text: (
        <ul className={styles.list}>
          <li>Актуальность науки о сне. Геронтосомнология.</li>
          <li>Международная классификация расстройств сна (МКБ-10)</li>
          <li>Физиология сна в молодом возрасте и при старении</li>
          <li>Механизмы цикла «бодрствование-сон»</li>
          <li>Хронобиология сна</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 2. Клиническая сомнология',
      key: 'module-2',
      text: (
        <ul className={styles.list}>
          <li>Инсомния: патогенез и диагностика </li>
          <li>Нарушения дыхания во сне: диагностика и лечение</li>
          <li>Инструментальные методы диагностики в сомнологии</li>
          <li>Принципы СИПАП/БИПАП-терапии</li>
          <li>Нарушения циркадных ритмов сна в молодом и пожилом возрасте</li>
          <li>Нарушения сна – типичный гериатрический синдром </li>
          <li>Нарушения сна при деменции</li>
          <li>Нарушения сна при болезни Альцгеймера</li>
        </ul>
      ),
    },
    {
      title:
        'Модуль 3. Современные медикаментозные и нелекарственные подходы к лечению инсомнии. Как избежать ошибок при лечении?',
      key: 'module-3',
      text: (
        <ul className={styles.list}>
          <li>Рациональная фармакотерапия и нелекарственные подходы к лечению инсомнии</li>
          <li>Лекарственно-индуцированные расстройства сна</li>
          <li>Лекарственно-индуцированная инсомния</li>
          <li>Лекарственно-индуцированное апноэ сна</li>
        </ul>
      ),
    },
  ],
}

const GktProgram = {
  title: 'Программа курса',
  data: [
    {
      title: 'Модуль 1. Заболевания верхних отделов желудочно-кишечного тракта у пожилых пациентов',
      key: 'module-1',
      text: (
        <ul className={styles.list}>
          <li>Кислотозависимые заболевания в гериатрической практике</li>
          <li>Гастроэзофагеальная рефлюксная болезнь у пожилых лиц</li>
          <li>Дисфагия: дифференциальная диагностика и тактика ведения пациентов</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 2. Дисфункциональные заболевания желудочно-кишечного тракта',
      key: 'module-2',
      text: (
        <ul className={styles.list}>
          <li>Функциональная диспепсия у пожилых пациентов</li>
          <li>Синдром раздражённого кишечника у лиц пожилого возраста</li>
          <li>Клинические примеры дисфункциональных заболеваний желудочно-кишечного тракта</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 3. Воспалительные заболевания кишечника',
      key: 'module-3',
      text: (
        <ul className={styles.list}>
          <li>Язвенный колит</li>
          <li>Болезнь Крона</li>
          <li>
            Диагностика и лечение воспалительных заболеваний кишечника: актуальные клинические
            рекомендации
          </li>
        </ul>
      ),
    },
  ],
}

const FAQdata = {
  title: 'Часто задаваемые вопросы',
  data: [
    {
      title: 'В какие даты проводится курс?',
      key: 'dates',
      text: (
        <>
          После оплаты вы сможете выбрать любой период прохождения курса. Для получения баллов НМО
          вам необходимо будет выполнить итоговое тестирование в эти даты. Выбрать данный период
          можно в любой момент.
        </>
      ),
    },
    {
      title: 'Какое расписание лекций?',
      key: 'timetable',
      text: (
        <>
          Курс состоит из заранее подготовленных материалов, поэтому изучать их вы сможете в любое
          время.
        </>
      ),
    },
    {
      title: 'Есть ли возможность пересматривать лекции?',
      key: 'rewatch',
      text: <>Да, доступ к материалам останется с вами навсегда.</>,
    },
    {
      title: 'Как получить баллы НМО за курс?',
      key: 'nmoHow',
      text: (
        <>
          После окончания выбранного вами периода прохождения курса и успешно выполненного итогового
          тестирования, баллы автоматически засчитаются на портале НМО. Также в личном кабинете вы
          сможете найти удостоверение установленного образца.
        </>
      ),
    },
  ],
}

const GeriatricsBasicProgram = {
  title: 'Программа курса',
  data: [
    {
      title: 'Модуль 1. Основы геронтологии и гериатрии. Гериатрическая служба в России',
      key: 'module-1',
      text: (
        <ul className={styles.list}>
          <li>Гериатрическая служба в России</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 2. Комплексная гериатрическая оценка (КГО)',
      key: 'module-2',
      text: (
        <ul className={styles.list}>
          <li>
            Особенности фармакотерапии в пожилом возрасте. Депрескрайбинг лекарственных препаратов
          </li>
        </ul>
      ),
    },
    {
      title: 'Модуль 3. Возраст-ассоциированные заболевания и тактика их ведения',
      key: 'module-3',
      text: (
        <ul className={styles.list}>
          <li>Артериальная гипертония: особенности ведения пожилых пациентов</li>
          <li>Остеоартрит</li>
          <li>Урологические заболевания в пожилом возрасте</li>
        </ul>
      ),
    },
  ],
}

const MiniCardioProgram = {
  title: 'Программа курса',
  data: [
    {
      title:
        'Модуль 1. Оценка сердечно-сосудистого риска и немедикаментозная профилактика сердечно-сосудистых заболеваний',
      key: 'module-1',
      text: (
        <ul className={styles.list}>
          <li>Оценка сердечно-сосудистого риска</li>
          <li>Немедикаментозная профилактика</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 2. Ишемическая болезнь сердца',
      key: 'module-2',
      text: (
        <ul className={styles.list}>
          <li>Диагностика ИБС</li>
          <li>Медикаментозная терапия</li>
          <li>Хирургическое лечение</li>
          <li>Необструктивная ишемическая болезнь сердца</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 3. Хроническая сердечная недостаточность ',
      key: 'module-3',
      text: (
        <ul className={styles.list}>
          <li>Сердечная недостаточность: алгоритм диагностики и лечения </li>
          <li>Клиника Сердечной Недостаточности от «приказов» к «практике» </li>
          <li>Острая декомпенсация СН </li>
        </ul>
      ),
    },
    {
      title: 'Модуль 4. Фибрилляция предсердий',
      key: 'module-4',
      text: (
        <ul className={styles.list}>
          <li>Фибрилляция предсердий (медикаментозное лечение)</li>
          <li>Фибрилляция предсердий (хирургическое лечение)</li>
        </ul>
      ),
    },
  ],
}

const ModernMethodsDmpProgram = {
  title: 'Программа курса',
  data: [
    {
      title: 'Модуль 1. Введение и цели курса',
      key: 'module-1',
      text: (
        <ul className={styles.list}>
          <li>Презентация курса</li>
          <li>Обзор целей и ожидаемых результатов</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 2. Клинические стандарты и рекомендации',
      key: 'module-2',
      text: (
        <ul className={styles.list}>
          <li>Лекция по актуальным клиническим рекомендациям</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 3. Современные методики ДМН',
      key: 'module-3',
      text: (
        <ul className={styles.list}>
          <li>Функционал и возможности платформы</li>
          <li>Информационные системы в ДМН</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 4. Модуль по артериальной гипертензии (АГ)',
      key: 'module-4',
      text: (
        <ul className={styles.list}>
          <li>Эпидемиология и клиническая значимость АГ</li>
          <li>Стандарты диагностики и мониторинга АГ</li>
          <li>Целевые уровни артериального давления</li>
          <li>Медикаментозное и немедикаментозное лечение</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 5. Модуль по сахарному диабету 2 типа (СД)',
      key: 'module-5',
      text: (
        <ul className={styles.list}>
          <li>Основы СД и его влияние на здоровье</li>
          <li>Стандарты мониторинга глюкозы крови</li>
          <li>Лекарственная терапия СД 2 типа</li>
          <li>Взаимодействие СД с другими хроническими заболеваниями</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 6. Модуль по дистанционному мониторингу детей с ЛОР заболеваниями',
      key: 'module-6',
      text: (
        <ul className={styles.list}>
          <li>Введение и клиническая значимость ЛОР заболеваний у детей</li>
          <li>Использование медицинских устройств для диагностики и мониторинга</li>
          <li>Обзор и применение платформы ДМН для мониторинга детей</li>
          <li>Примеры из практики</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 7. Решение типичных клинических задач',
      key: 'module-7',
      text: (
        <ul className={styles.list}>
          <li>Обсуждение типичных клинических случаев</li>
          <li>Разработка стратегий улучшения лечения</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 8. Заключение и подведение итогов',
      key: 'module-8',
      text: (
        <ul className={styles.list}>
          <li>Повторение ключевых моментов курса</li>
          <li>Обсуждение возможностей дальнейшего обучения и профессионального развития</li>
        </ul>
      ),
    },
    {
      title: 'Модуль 9. Тестирование и оценка знаний',
      key: 'module-9',
      text: (
        <ul className={styles.list}>
          <li>Итоговое тестирование</li>
        </ul>
      ),
    },
  ],
}

export {
  FAQdata,
  CardioProgram,
  NeuroProgram,
  GeriatricsProgram,
  OsteporosisProgram,
  SomnologyProgram,
  GktProgram,
  GeriatricsBasicProgram,
  MiniCardioProgram,
  ModernMethodsDmpProgram,
}
export type { IAccordeonCardioData }
